<div
  *render="isForRoot"
  [routerLink]="routerLink"
  class="w-full flex justify-start items-center cursor-pointer group transition-all duration-200 mb-1 py-2 pl-4 pr-3 relative"
  [ngClass]="{
    'bg-primary rounded-none': isActive,
    'rounded-md hover:bg-slate-50': !isActive,
  }"
  [pTooltip]="tooltip"
  [tooltipDisabled]="!collapse"
>
  <div class="w-6 h-6 flex-shrink-0 relative mr-2">
    <img
      [src]="isActive ? iconoActivo : iconoInactivo"
      alt="Icon"
      class="icon w-6 h-6 object-contain"
    />
  </div>
  @if (!collapse) {
    <a
      animate.enter="fade-enter"
      animate.leave="fade-leave"
      style="--time: 50ms"
      class="transition-all duration-200"
      [ngClass]="{
        'text-slate-600': !isActive,
        'text-white font-bold': isActive,
      }"
      [routerLink]="routerLink"
    >
      {{ titulo }}
    </a>
  }
</div>

<ng-template #tooltip>
  <div>
    <small>{{ titulo }}</small>
  </div>
</ng-template>
